<template>
    <Panel title="Stamdata">
        <table class="table is-fullwidth">
            <tbody>
            <tr>
                <td>ID</td>
                <td>{{ item.id }}</td>
            </tr>
            <tr v-if="item.item_subcategory_id">
                <td>Kategori</td>
                <td v-if="item.subsubcategory">
                    {{ item.subsubcategory.name }} ({{ item.subcategory.name }} / {{ item.category.name }})
                </td>
                <td v-else>{{ item.subcategory.name }} ({{ item.category.name }})</td>
            </tr>
            <tr>
                <td>Fabrikant</td>
                <td v-if="item.manufacturer">{{ item.manufacturer.name }}</td>
                <td v-else>-</td>
            </tr>
            <tr>
                <td>Model</td>
                <td>{{ item.model }}</td>
            </tr>
            <tr v-if="item.customs_code">
                <td>Toldkode</td>
                <td>{{ item.customs_code }}</td>
            </tr>
            <tr v-if="item.ean">
                <td>EAN</td>
                <td>{{ item.ean }}</td>
            </tr>
            <template v-if="item.type.real_item">
                <tr v-if="item.weight">
                    <td>Vægt</td>
                    <td>{{ item.weight_display }}</td>
                </tr>
                <tr v-if="item.itemLength">
                    <td>Længde</td>
                    <td>{{ `${item.itemLength} cm` }}</td>
                </tr>
                <tr v-if="item.width">
                    <td>Bredde</td>
                    <td>{{ `${item.width} cm` }}</td>
                </tr>
                <tr v-if="item.height">
                    <td>Højde</td>
                    <td>{{ `${item.height} cm` }}</td>
                </tr>
            </template>
            <tr v-for="property in properties" :key="property.id">
                <td>{{ property.name }}</td>
                <td>{{ property.terms.map(term => term.name).join(', ') }}</td>
            </tr>
            <tr>
                <td>Oprindelsesland</td>
                <td v-if="item.country">{{ item.country.title }}</td>
                <td v-else>-</td>
            </tr>
            <tr v-if="showAdminFields">
                <td>Primær leverandør</td>
                <td v-if="item.primary_supplier">{{ item.primary_supplier.name }}</td>
                <td v-else>-</td>
            </tr>
            <tr v-if="showAdminFields">
                <td>Sekundær leverandør</td>
                <td v-if="item.secondary_supplier">{{ item.secondary_supplier.name }}</td>
                <td v-else>-</td>
            </tr>
            <tr v-if="showAdminFields">
                <td>Max. rabat</td>
                <td>{{ item.max_discount_display }}</td>
            </tr>
            <tr v-if="showAdminFields">
                <td>Kostpris</td>
                <td :class="{'is-outdated': item.cost_price.outdated}">
                    <span>
                        {{ item.cost_price.price_display }}
                    </span>
                    <a class="button ml-auto is-small costprice-btn" title="Historik" @click.prevent="$emit('showHistory')">
                        <span class="icon"><i class="fas fa-history"/></span>
                    </a>
                    <a
                        v-if="item.cost_price.outdated"
                        title="Bekræft kostpris"
                        class="button ml-1 is-small costprice-btn"
                        @click.prevent="$emit('confirmCostPrice')"
                    >
                        <span class="icon is-green"><i class="fas fa-check"/></span>
                    </a>
                </td>
            </tr>
            </tbody>
        </table>
    </Panel>

</template>

<script>
import Panel from "@elems/Panel";

export default {
    components: { Panel },
    props: {
        item: {
            type: Object,
            required: true,
        },
        showAdminFields: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        properties() {
            return this.item.terms.reduce((properties, term) => {
                const property = properties.find(property => property.id === term.property.id)
                if (property) {
                    property.terms.push(term)
                } else {
                    properties.push({
                        id: term.property.id,
                        name: term.property.name,
                        terms: [term],
                    })
                }
                return properties
            }, [])
        },
    },
}
</script>

<style scoped>
table tbody tr td:first-child {
    width: 40% !important;
}
table tbody tr td:not(first-child) {
    width: auto !important;
}
.costprice-btn {
    width: 1.5rem;
    height: 1.5rem;
}
</style>

